import React, {FunctionComponent} from "react"
import {useNavigate} from "react-router-dom"
import {createUserMutation} from "@murphy-frontend/common/api/Users/Mutations"
import Button from "@murphy-frontend/web-core/components/Button"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import {CreateUserRequest} from "@murphy-frontend/common/interfaces/IUsersApi"
import UserForm from "@murphy-frontend/web-core/features/UsersAdmin/components/UserForm"
import FeatureServiceType, {IFeatureService} from "@murphy-frontend/common/interfaces/IFeatureService"
import {useInjection} from "@murphy-frontend/common/contexts/InversifyContext"
import ComponentWrapper from "../../../common/components/ComponentWrapper"

const AddUser: FunctionComponent = () => {
	const navigate = useNavigate()
	const {customer, allCustomerProducts} = useCustomer()
	const {translations} = useUserPreferences()

	const onClickBack = () => {
		navigate(-1)
	}

	const {mutate: createMutate, isPending: isLoading} = createUserMutation(translations)
	const featureService = useInjection<IFeatureService>(FeatureServiceType.IFeatureService)

	const onSubmitHandler = (createData: any) => {
		const createUserRequest: CreateUserRequest = {
			CustomerId: customer.Id
		}

		if (createData.selectedproductids) {
			createUserRequest.InitialProducts = createData.selectedproductids
		}

		if (createData.phonenumber) {
			createUserRequest.Phonenumber = createData.phonenumber
		}

		if (createData.email) {
			createUserRequest.Email = createData.email
		}

		if (createData.username) {
			createUserRequest.Username = createData.username
		}

		if (createData.role >= 0) {
			createUserRequest.Role = createData.role
		}

		if (Object.keys(createUserRequest).length > 0) {
			createMutate(createUserRequest, {
				onSuccess: () => {
					navigate(-1)
				}
			})
		}
	}

	const isUserNameDisabled = featureService.isUserNameDisabled()
	const isEmailDisabled = featureService.isEmailDisabled()
	const isPhoneNumberDisabled = featureService.isPhoneNumberDisabled()
	const isUpsertUserEnabled = featureService.isUpsertUserEnabled()

	return (
		<ComponentWrapper active={8} subMenuActive={1}>
			<div className='generalwrapper padding-bottom-60'>
				<section className='header-container vertical-aligner'>
					<div className='one'>
						<h4>{translations.newuser.toUpperCase()}</h4>
					</div>
					<div className='two'>
						<div>
							<Button
								isIconButton
								isNeutralButton
								buttonStyle='btn--back'
								buttonSize='btn-with-icon'
								onClick={onClickBack}
							/>
						</div>
					</div>
					<div className='three' />
				</section>
				<section className='container-with-background'>
					<div className='form-container'>
						<UserForm
							translations={translations}
							allProducts={allCustomerProducts}
							showResetPassword={false}
							onSubmit={onSubmitHandler}
							isSetPermissionsReadonly={false}
							isSetRoleReadonly={false}
							isLoading={isLoading}
							isUserNameDisabled={isUserNameDisabled}
							isEmailDisabled={isEmailDisabled}
							isPhoneNumberDisabled={isPhoneNumberDisabled}
							isUpsertUserEnabled={isUpsertUserEnabled}
						/>
					</div>
				</section>
			</div>
		</ComponentWrapper>
	)
}

export default AddUser
